import { render, staticRenderFns } from "./SelectedHucBox.vue?vue&type=template&id=c921b100&"
import script from "./SelectedHucBox.vue?vue&type=script&lang=js&"
export * from "./SelectedHucBox.vue?vue&type=script&lang=js&"
import style0 from "./SelectedHucBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports